export enum Tabs {
  CONTENT = 'etusivu',
  INFO = 'lisatiedot',
  MY_CERTIFICATES = 'omat-todistukset',
}
